const register = {
  state: {
    phone: '',
    imgVerifyCode: '',
    hospitalInfo: {}
  },
  mutations: {
    SAVE_PHONE (state, item) {
      state.phone = item.phone
      state.imgVerifyCode = item.imgVerifyCode
    },
    SAVE_HOS (state, item) {
      state.hospitalInfo = item
    }
  },
  actions: {
    savePhone ({
      commit, state
    }, item) {
      commit('SAVE_PHONE', item)
    }
  }
}
export default register